<template>
  <LoadingScreen :visible="true" />
</template>

<script>
import { mapActions } from 'vuex';

import LoadingScreen from '@/js/components/LoadingScreen.vue';
import toast from '../../components/toast/toast';
import ShowsService from '../../services/shows';

export default {
  name: 'CreateProductionFromShow',

  components: {
    LoadingScreen,
  },

  created() {
    this.run();
  },

  methods: {
    ...mapActions(['setOwner', 'getUserAccounts', 'createProduction']),

    async run() {
      const { showId } = this.$route.params;
      const owner = Number(this.$route.query.owner);
      const showTitle = this.$route.query.title || 'New show';
      const title = `Generated Show: ${showTitle}`;

      if (!showId || !owner) {
        this.$router.replace('/');
        return;
      }

      if (this.$store.state.user.id !== owner) {
        const accounts = await this.getUserAccounts();
        const ownerIds = Object.keys(accounts.owners || {}).map(Number);

        if (!ownerIds.includes(owner)) {
          this.$router.replace('/');
          return;
        }
      }

      // Load (and implicitly authorize) the Show before creating anything,
      // so a missing/inaccessible Show never leaves behind an orphan production.
      try {
        await ShowsService.getShow(showId);
      } catch (err) {
        console.error(`Failed to load show ${showId}:`, err);

        toast.makeToast({
          heading: 'Error',
          icon: 'error',
          loaderBg: 'red',
          text: 'Failed to load show.',
        });

        this.$router.replace('/');
        return;
      }

      this.setOwner(owner);

      let productionId;
      try {
        productionId = await this.createProduction({ title, tags: [], flagged: false });
      } catch (err) {
        console.error(`Failed to create production for show ${showId}:`, err);

        toast.makeToast({
          heading: 'Error',
          icon: 'error',
          loaderBg: 'red',
          text: 'Failed to create production.',
        });

        this.$router.replace('/');
        return;
      }

      // Hand off to the normal production route, which appends the Show to
      // the timeline via the same `?addShow=` handoff used to add a Show to
      // an existing production.
      this.$router.replace({
        name: 'production',
        params: { production_id: productionId },
        query: { addShow: showId },
      });
    },
  },
};
</script>
